import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SiteDetailUpdate from "../components/SiteDetailUpdate";

const SiteDetailsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Update Website Info' />

        <SiteDetailUpdate />

      </MasterLayout>
    </>
  );
};

export default SiteDetailsPage;
